import { countryNameMapper } from './localeHelper';

export const getCountryName = (country: string): string => countryNameMapper[country] || country;
